export default __webpack_public_path__ + "4140a04e53e303dab3ea5a1c0f4fc88a.mp3";